// extracted by mini-css-extract-plugin
export var title = "styles-module--title--e9d0e";